// Hack for when the "name insert" is at the end of a sentence
const invertNameInsertSpaces = (nameInsert: string) => {
  if (nameInsert.length > 0) {
    return ` ${nameInsert.slice(0, -1)}`
  }
  return nameInsert
}

export const ACCOUNT_TEXT = {
  'account.marketing_preferences.title': {
    'en-GB': 'Contact Preferences',
    'nl-NL': 'Contactvoorkeuren',
  },
  'account.marketing_preferences.error': {
    'en-GB': 'Please reload the page and try again',
    'nl-NL': 'Probeer het opnieuw door de pagina te vernieuwen',
  },
  'account.marketing_preferences.loading': {
    'en-GB': 'loading',
    'nl-NL': 'aan het laden',
  },
  'account.marketing_preferences.text': {
    'en-GB': 'Receive updates of the latest news and offers',
    'nl-NL': 'Updates met kortingen, acties & nieuwtjes.',
  },
  'account.moonpig_plus.text': {
    'en-GB': 'Receive exclusive Moonpig Plus updates and offers',
    'nl-NL': 'Exclusieve Greetz Plus-updates en aanbiedingen ontvangen',
  },
  'account.reminders.title': {
    'en-GB': 'Reminders',
    'nl-NL': 'Kalendermomenten',
  },
  'account.reminders.link': {
    'en-GB': 'Manage your Reminders',
    'nl-NL': 'Je momenten beheren',
  },
  'account.sold_out': {
    'en-GB': 'This item is either sold out or no longer available.',
    'nl-NL': 'Dit artikel is uitverkocht of niet langer beschikbaar',
  },
  'account.its_not_you': {
    'en-GB': 'It’s not you, it’s us. Please try again!',
    'nl-NL': 'Het ligt niet aan jou, het ligt aan ons. Probeer het nog eens!',
  },
  'account.reset_password.title': {
    'en-GB': 'Reset Password | Moonpig',
    'nl-NL': 'Wachtwoord opnieuw instellen | Greetz',
  },
  'account.reset_password.invalid_password': {
    'en-GB':
      'Enter 8 characters or more including one upper case, one lower case and a number',
    'nl-NL':
      'Geef 8 tekens of meer in, waaronder een hoofdletter, kleine letter en een cijfer.',
  },
  'account.reset_password.error': {
    'en-GB': 'Failed to reset the password',
    'nl-NL': 'Het is niet gelukt om het wachtwoord opnieuw in te stellen.',
  },
  'account.reset_password.invalid_token': {
    'en-GB': 'Invalid token!',
    'nl-NL': 'Token is ongeldig.',
  },
  'account.reset_password.cookie_error': {
    'en-GB': 'Oops! You need to have cookies enabled to use this feature',
    'nl-NL':
      'Oeps! Om deze functie te gebruiken moet je even de cookies inschakelen.',
  },
  'account.reset_password': {
    'en-GB': 'Reset Password',
    'nl-NL': 'Wachtwoord opnieuw instellen',
  },
  'account.reset_password.requirements': {
    'en-GB':
      '8 characters or more including one upper case, one lower case and a number.',
    'nl-NL':
      '8 tekens of meer, waaronder een hoofdletter, kleine letter en een cijfer.',
  },
  'account.reset_password.new_password': {
    'en-GB': 'New password',
    'nl-NL': 'Nieuw wachtwoord',
  },
  'account.reset_password.password': {
    'en-GB': 'Password',
    'nl-NL': 'Wachtwoord',
  },
  'reminder_for_order.set_email': {
    'en-GB': 'Set Reminder Email',
    'nl-NL': 'Stel herinnering in',
  },
  'common.reminders_card_error_text': {
    'en-GB': "Oops, that didn't save this time.",
    'nl-NL': 'Oeps, het is niet opgeslagen.',
  },
  'account.next_best_actions.continue_your_creation': {
    'en-GB': 'Continue your creation',
    'nl-NL': 'Ga verder met je creatie',
  },
  'account.next_best_actions.your_recent_order': {
    'en-GB': 'Your Recent Order',
    'nl-NL': 'Je recente bestelling',
  },
  'account.next_best_actions.my_account': {
    'en-GB': 'My Account',
    'nl-NL': 'Mijn account',
  },
  'account.next_best_actions.details': {
    'en-GB': 'Details',
    'nl-NL': 'details',
  },
  'account.next_best_actions.recent_order.order_number': {
    'en-GB': 'Order Number: ',
    'nl-NL': 'Ordernummer: ',
  },
  'account.next_best_actions.recent_order.split': {
    'en-GB': (c: { totalDeliveries: number }) =>
      `Your order has been split into ${c.totalDeliveries} deliveries.`,
    'nl-NL': (c: { totalDeliveries: number }) =>
      `Je bestelling is opgesplitst in ${c.totalDeliveries} leveringen.`,
  },
  'account.next_best_actions.recent_order.delivery_of': {
    'en-GB': (c: { deliveryIndex: number; totalDeliveries: number }) =>
      `Delivery ${c.deliveryIndex} of ${c.totalDeliveries}`,
    'nl-NL': (c: { deliveryIndex: number; totalDeliveries: number }) =>
      `Bezorging ${c.deliveryIndex} van ${c.totalDeliveries}`,
  },
  'account.next_best_actions.recent_order.name_insert': {
    'en-GB': (c: { recipientName: string }) => `for ${c.recipientName} `,
    'nl-NL': (c: { recipientName: string }) => `voor ${c.recipientName} `,
  },
  'account.next_best_actions.recent_order.name_insert_postfix': {
    'en-GB': (c: { recipientName: string }) => `${c.recipientName} `,
    'nl-NL': (c: { recipientName: string }) => `${c.recipientName} kan je `,
  },
  'account.next_best_actions.recent_order.no_name_insert_postfix': {
    'en-GB': `You `,
    'nl-NL': `Je kan de `,
  },
  'account.next_best_actions.recent_order.cancelled': {
    'en-GB': (c: { nameInsert: string }) =>
      `Your order ${c.nameInsert}has been cancelled!`,
    'nl-NL': (c: { nameInsert: string }) =>
      `Je bestelling ${c.nameInsert}is geannuleerd!`,
  },
  'account.next_best_actions.recent_order.on_hold': {
    'en-GB': (c: { nameInsert: string }) =>
      `Your order ${c.nameInsert}is on hold!`,
    'nl-NL': (c: { nameInsert: string }) =>
      `Je bestelling ${c.nameInsert}staat in de wacht!`,
  },
  'account.next_best_actions.recent_order.sent_delivered_from': {
    'en-GB': (c: { nameInsert: string }) =>
      `Your order ${c.nameInsert}should have been delivered from`,
    'nl-NL': (c: { nameInsert: string }) =>
      `Je bestelling ${c.nameInsert}is naar verwachting geleverd vanaf`,
  },
  'account.next_best_actions.recent_order.sent_loved_it.their_address': {
    'en-GB': `We hope they loved it!`,
    'nl-NL': 'We hopen dat ze het leuk vinden!',
  },
  'account.next_best_actions.recent_order.sent_loved_it.own_address': {
    'en-GB': `We hope you loved it!`,
    'nl-NL': 'We hopen dat je het leuk vindt!',
  },
  'account.next_best_actions.recent_order.sent_out': {
    'en-GB': (c: { nameInsert: string }) =>
      `Your order ${c.nameInsert}is out for delivery. Earliest delivery from:`,
    'nl-NL': (c: { nameInsert: string }) =>
      `Je bestelling is onderweg! ${c.nameInsert}verrassing verwachten vanaf`,
  },
  'account.next_best_actions.recent_order.printing': {
    'en-GB': (c: { nameInsert: string }) =>
      `Your order ${c.nameInsert}is being packed. Earliest delivery from:`,
    'nl-NL': (c: { nameInsert: string }) =>
      `Je bestelling ${c.nameInsert}wordt ingepakt en wordt verwacht geleverd te worden op`,
  },
  'account.next_best_actions.recent_order.received': {
    'en-GB': (c: { nameInsert: string }) =>
      `We have received your order${invertNameInsertSpaces(
        c.nameInsert,
      )}. Earliest delivery from:`,
    'nl-NL': (c: { nameInsert: string }) =>
      `We hebben uw bestelling ${c.nameInsert}ontvangen en deze wordt verwacht te worden geleverd op`,
  },
  'account.design_draft.your_draft_is_waiting': {
    'en-GB': 'Your Draft is Waiting',
    'nl-NL': 'Je ontwerp wacht op je',
  },
  'account.design_draft.continue_editing': {
    'en-GB': 'Continue Editing',
    'nl-NL': 'Bewerken',
  },
  'account.design_draft.delete_draft': {
    'en-GB': 'Delete Draft',
    'nl-NL': 'Concept Verwijderen',
  },
  'account.design_draft.sure_delete': {
    'en-GB': 'Sure you want to delete?',
    'nl-NL': 'Weet je zeker dat je dit wilt verwijderen?',
  },
  'account.design_draft.customisation_will_be_lost': {
    'en-GB': 'Any customisations will be lost.',
    'nl-NL': 'Eventuele aanpassingen gaan verloren',
  },
  'account.design_draft.yes_delete': {
    'en-GB': 'Yes, Delete',
    'nl-NL': 'Ja, verwijderen',
  },
  'account.design_draft.cancel': {
    'en-GB': 'Cancel',
    'nl-NL': 'Annuleren',
  },
  'account.back': {
    'en-GB': 'Back',
    'nl-NL': 'Terug',
  },
}
